import React, { useEffect, useState } from 'react';
import { CentralProviderFooter } from '@michelin/central-provider';
import { runningOnCanvas } from '@michelin/central-provider/dist/utils/canvas';
import { auth } from 'Auth';
import { getVersion, getRestApiVersion } from 'components/Util/version';

export function Footer() {
  const [restApiVersion, setRestApiVersion] = useState<string>('...');

  useEffect(() => {
    getRestApiVersion().then(setRestApiVersion).catch(() => setRestApiVersion('...'));
  }, []);

  if (runningOnCanvas()) return null;
  return (
    <CentralProviderFooter
      versions={[
        {
          application: 'UI',
          version: getVersion() || '',
        },
        {
          application: 'API',
          version: `${auth.getApiVersion() || '...'} / ${restApiVersion}`,
        },
      ]}
      showLegalInformation={false}
      showCopyright
    />
  );
}
